'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Favorites = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Favorites = function Favorites(_ref) {
  var highlighted = _ref.highlighted,
      rest = (0, _objectWithoutProperties3.default)(_ref, ['highlighted']);
  return _react2.default.createElement(
    'li',
    (0, _extends3.default)({
      className: (0, _classnames2.default)('dropdown__item searchbox__favorites', {
        'dropdown__item--highlighted': highlighted
      })
    }, rest),
    _react2.default.createElement(
      'div',
      { className: 'dropdown__item__content' },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'searchbox.item.favorites',
        defaultMessage: 'Your favorites'
      })
    )
  );
};

exports.Favorites = Favorites;
Favorites.propTypes = {
  highlighted: _propTypes2.default.bool.isRequired
};